import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";

// import store from '@/state/store'
// import appConfig from "@/app.config";
import routes from "./routes";
import axios from "axios";
import { authHeader } from "../helpers/auth/auth-header";
axios.defaults.headers = authHeader();
import store from "@/state/store";
import { menuItems } from "../components/menu";

Vue.use(VueRouter);
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: "page",
});
/* eslint-disable */
const router = new VueRouter({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'hash',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom, next) => {
  const publicPages = ["/login", "/register", "/forgot-password"];
  const webviewPages = ["/fieldmr/dashboard"];
  const authpage = !publicPages.includes(routeTo.path);
  let loggeduser = false;
  if(!webviewPages.includes(routeTo.path)){
    try {
        let user = JSON.parse(localStorage.getItem("user"));
        if (store.state.token != null && user.token === store.state.token) {
          loggeduser = true;
        } else {
          let res = await axios.get(process.env.VUE_APP_API_BACKEND_URL + "auth/isLoggedIn", {
            headers: {
              Authorization: "Bearer " + user.token,
              Accept: "application/json",
            },
          });
          if (res.data.token) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            store.commit("setToken", res.data.token);
            store.commit("setRole", res.data.roles)
            store.commit("setPermissions", res.data.permissions)
            store.commit("setRestaurant", res.data.restaurant)
            // Preserve impersonated_by if it was set
            if (user && user.impersonated_by) {
              res.data.impersonated_by = user.impersonated_by;
            }
            localStorage.setItem("user", JSON.stringify(res.data));
            user = JSON.parse(localStorage.getItem("user"));
            loggeduser = true;
          }else{
            loggeduser = res;
          }
          store.commit("setToken", user.token);
        }
      } catch (e) {
        loggeduser = false;
      }
      if (authpage && !loggeduser) {
        return next("/login");
      }
      // if(store.state.authfack.user.roles.filter(f => f.name != 'SuperAdmin').length > 0 && store.state.authfack.user.permissions.map(p => p.name).includes('GravyOrder')){
      //   return next({name : "Gravy Orders"})
      // }else if(store.state.authfack.user.roles.filter(f => f.name != 'SuperAdmin').length > 0 && store.state.authfack.user.permissions.map(p => p.name).includes('RestaurantPartner')){
      //   return next({name : "Restaurants"});
      // }else if(store.state.authfack.user.roles.filter(f => f.name != 'SuperAdmin').length > 0 && store.state.authfack.user.permissions.map(p => p.name).includes('Analytics')){
      //   return next({name : "Gravy Projection"});
      // }                  
      let permission = findValue(menuItems,routeTo.path);        
      // eslint-disable-next-line     
      if(permission != '' && store.state.authfack.user && (!store.state.authfack.user?.permissions.map(p => p.name).includes(permission) && !store.state.authfack?.user?.roles.filter(f => f.name == 'SuperAdmin').length > 0) && routeTo.path != "/" && routeTo.path != "/logout" && authpage){        
        return next("/");
      }
      if(!authpage && loggeduser) {        
        // if(store.state.authfack.user.permissions.map(p => p.name).includes() || store.state.authfack.user.roles.filter(f => f.name == 'SuperAdmin').length > 0)
        return next("/");
      }
  }
  next();
});


function findValue(obj, targetValue) {
  let found = ''; // Flag to indicate if the target value was found

  function search(obj) {
      // Iterate through each key in the object
      for (let key in obj) {
          // If the key maps to an object, recursively search it
          if (typeof obj[key] === 'object' && obj[key] !== null) {
              search(obj[key]);
          } else {
              // If the current value matches the target value, set the flag to true
              if (obj[key] === targetValue) {
                  found = obj['permission'];
                  break; // Exit the loop if the value is found
              }
          }
      }
  }

  search(obj); // Start the search
  return found; // Return the result of the search
}

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          // Otherwise, continue resolving the route.
          resolve();
        }
      });
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    console.log(error);
    return;
  }

  // If we reach this point, continue resolving the route.
  next();
});

router.afterEach((to) => {
  // Use setTimeout to delay the tracking call so it doesn't compete with the main page load
  setTimeout(() => {
    try {
      const userData = JSON.parse(localStorage.getItem("user"));
      // In this app, the user profile is nested inside the 'user' key of the stored object
      const userName = userData?.user?.name || userData?.name || "Guest";

      // Identifying the section from menuItems
      let sectionName = "General";
      if (menuItems) {
        const menuEntry = menuItems.find(item => 
          item.subItems && item.subItems.some(sub => sub.link === to.path)
        );
        if (menuEntry) {
          sectionName = menuEntry.label;
        }
      }

      // Ping backend
      axios.post(process.env.VUE_APP_API_BACKEND_URL + "track_heatlog", {
        user: userName,
        section: sectionName,
        page: to.name || to.path
      }).catch(() => {
        // Fail silently
      });
    } catch (err) {
      // Silent fail
    }
  }, 1000); // 1 second delay
});

export default router;
